<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="footer">
          <div class="copyright">&copy; {{year}} Hunora.com</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        year: 0
      };
    },
    mounted() {
      this.year = this.getYear();
    },
    methods: {
      getYear() {
        const date = new Date();
        return date.getFullYear();
      }
    }
  };
</script>
